import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["voice", "error", "button"]
  static values = { url: String, error: String }

  async play(event) {
    event.preventDefault()
    this.errorTarget.textContent = ""
    this.buttonTarget.disabled = true
    try {
      const token = document.querySelector('meta[name="csrf-token"]')?.content ?? ""
      const response = await fetch(this.urlValue, {
        method: "POST",
        headers: {
          "X-CSRF-Token": token,
          "Content-Type": "application/x-www-form-urlencoded",
          Accept: "audio/wav"
        },
        body: new URLSearchParams({ voice: this.voiceTarget.value })
      })
      if (!response.ok) {
        this.errorTarget.textContent = this.errorValue
        return
      }
      const blob = await response.blob()
      const objectUrl = URL.createObjectURL(blob)
      const audio = new Audio(objectUrl)
      audio.addEventListener("ended", () => URL.revokeObjectURL(objectUrl), { once: true })
      await audio.play()
    } catch (_err) {
      this.errorTarget.textContent = this.errorValue
    } finally {
      this.buttonTarget.disabled = false
    }
  }
}
